import styled from "styled-components";

import { AuthModalButtonContainer } from "../../atoms/AuthModalButton/styles";

interface IAuthenticationModalContainerProps {
  showLoginModal: boolean;
}
export const AuthenticationModalContainer = styled.section<IAuthenticationModalContainerProps>`
  align-items: center;
  display: flex;
  justify-content: center;

  width: 100%;
  height: 100vh;
  padding: 1.5rem 0;

  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(8px);

  position: fixed;
  top: 0;
  left: 0;

  transition: all 0.3s ease-in-out;
  z-index: ${({ showLoginModal }) => (showLoginModal ? "1000" : "-1")};

  ${AuthModalButtonContainer} {
    height: 2.25rem;
  }

  .editor-input {
    display: grid;
    place-items: center;
    padding: 0 !important;

    * {
      text-align: center !important;
      font-size: 0.813rem !important;
      line-height: 20px !important;
    }
  }

  .loader {
    height: 1rem;
    width: 1rem;
  }
`;

interface IAuthenticationModalContentProps {
  showLoginModal: boolean;
}
export const AuthenticationModalContent = styled.div<IAuthenticationModalContentProps>`
  background-color: ${({ theme }) => theme.authModal.backgroundColor};

  padding: 1.25rem;
  margin: 0 1rem;

  border: 0.5px solid ${({ theme }) => theme.authModal.borderColor};
  border-radius: 1rem;

  width: 440px;

  transition: all 0.2s ease-in-out;

  pointer-events: ${({ showLoginModal }) => (showLoginModal ? "all" : "none")};
  opacity: ${({ showLoginModal }) => (showLoginModal ? "1" : "0")};
  transform: ${({ showLoginModal }) =>
    showLoginModal ? "translateY(0)" : "translateY(-5px)"};

  svg * {
    stroke: ${({ theme }) => theme.authModal.svgColor};
    fill: ${({ theme }) => theme.authModal.svgColor};
  }

  @media screen and (min-width: 768px) {
    max-width: 440px;
    height: auto;
  }
`;

export const AuthenticationModalControls = styled.div`
  display: flex;
  justify-content: space-between;

  ${AuthModalButtonContainer} {
    height: 1.5rem;
    width: 1.5rem;
  }
`;
